import React, {useEffect, useState} from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";
import {useQuery} from "@tanstack/react-query";
import formBuilderService from "../../../../services/web/form-builder-service.js";
import SelectComponent from "../../../../components/select/select-component.jsx";
import Button from "../../../../components/button/button.jsx";
import FiltersStructureModal from "./filters-structure-modal.jsx";
import clsx from "clsx";

const Filters = ({ setFilters, filters, modalOpen, setModalOpen, onApply }) => {
    const [formList, setFormList] = useState([]);

    const {data: moduleList} = useQuery({
        queryFn: () => formBuilderService.modules(),
        queryKey: ["modules"]
    });

    const {data: formListFetch} = useQuery({
        queryFn: () => formBuilderService.getAll().then((data) => data?.map(i => ({value: i.id, label: i.name, ...i}))),
        queryKey: ["forms-list"],
    });

    useEffect(() => {
        if (!formListFetch) return;

        setFormList(formListFetch.filter(({module}) => module === filters?.module?.value));
    }, [formListFetch, filters.module]);

    const selectedFields = filters.fields ?? [];

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>
                    <InputDateTime
                        id="dtStart"
                        label="Data/hora inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({...prev, dtStart: date}))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data/hora final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({...prev, dtEnd: date}))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <SelectComponent
                        value={filters.module}
                        options={moduleList}
                        label={"Módulo *"}
                        onChange={(value) => setFilters(prev => ({
                            ...prev,
                            module: value,
                            form: null,
                            fields: []
                        }))}
                    />

                    <SelectComponent
                        isDisabled={!filters.module}
                        value={filters.form}
                        options={formList}
                        label={"Formulário *"}
                        menuPlacement={"bottom"}
                        onChange={(value) => setFilters(prev => ({...prev, form: value, fields: []}))}
                    />

                    <Button
                        type={"button"}
                        target={"primary-outline"}
                        className={clsx("w-full", filters.fields?.length ? "border-[#ffa500]!" : "")}
                        disabled={!filters.form}
                        onClick={() => setModalOpen(true)}
                    >
                        Selecionar campos
                    </Button>
                </form>

                <FiltersStructureModal
                    open={modalOpen}
                    setOpen={setModalOpen}
                    form={filters.form}
                    value={selectedFields}
                    onConfirm={(fields) => setFilters(prev => ({...prev, fields}))}
                    onApply={onApply}
                />
            </div>
        </>
    );
};

export default Filters;
